/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_2Inputs */

const en_pc_tut_save_2 = /** @type {(inputs: Pc_Tut_Save_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes are autosaved every minute, and unsaved tabs show a dot.`)
};

const zh_pc_tut_save_2 = /** @type {(inputs: Pc_Tut_Save_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改每分钟自动保存一次，未保存的标签页会显示一个圆点。`)
};

/**
* | output |
* | --- |
* | "Changes are autosaved every minute, and unsaved tabs show a dot." |
*
* @param {Pc_Tut_Save_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_2 = /** @type {((inputs?: Pc_Tut_Save_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_2(inputs)
	return zh_pc_tut_save_2(inputs)
});
export { pc_tut_save_2 as "pc.tut.save.2" }